/** 저장 버튼 «저장 중…»이 한 프레임 이상 보이도록 */
const MIN_SAVING_LABEL_MS = 400;

export async function paintModalSaveInProgress(): Promise<void> {
  await new Promise<void>((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
  });
}

export async function holdModalSavingLabelMinDuration(startedAt: number): Promise<void> {
  const remain = Math.max(0, MIN_SAVING_LABEL_MS - (Date.now() - startedAt));
  if (remain > 0) {
    await new Promise<void>((resolve) => setTimeout(resolve, remain));
  }
}
